import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    Label,
    Input,
    FormGroup
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';
import saveIcon from '../../assets/svg/save-icon.svg';


import moment from 'moment';
import { API_ENDPOINT } from '../../constants';
import CustomCalendarFilterSelect from './customCalendarFilterSelect';
import ErrorModal from '../../components/errorModal';
import DeleteModal from '../../components/deleteModal';
import InfoModal from '../../components/infoModal';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class CustomFilterCalendar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            filter: {
                clinicians: [],
                professions: [],
                eventTypes: []
            }
        }
    }

    setInitialData = (initial = false, callbackCustomSelection = null) => {
        this.getClinicians(initial);
        this.getProfessions(initial);
        this.getEventTypes(initial);
        this.getCustomSelections(initial, callbackCustomSelection);
    }

    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians });
                }
            })
        });
    }
    getProfessions = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ professions: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/professions/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.professions?.length) {
                    this.setState({ professions: result.professions });
                }
            })
        });
    }

    getEventTypes = (initial = false) => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ eventTypes: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/event-types/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.eventTypes?.length) {
                    // let eventTypes = this.props.occupancy ? result.eventTypes.filter((item) => item?.thisClinic !== false) : result.eventTypes;
                    let eventTypes = result?.eventTypes.map((item) => {
                        if (this.props.occupancy) {
                            return {
                                ...item,
                                items: item?.items?.filter((el) => el?.thisClinic !== false)
                            }
                        } else {
                            return item;

                        }

                    });
                    this.setState({ eventTypes: eventTypes }, () => {
                        if (this.setEventTypes && initial) {
                            let values = [];
                            for (let i = 0; i < this.state.eventTypes.length; i++) {
                                const item = this.state.eventTypes[i];
                                values.push(item._id);
                                if (item?.items?.length) {
                                    for (let j = 0; j < item.items.length; j++) {
                                        const eventType = item.items[j];
                                        values.push(eventType._id);
                                    }
                                }
                            }
                            this.setEventTypes(values);
                        }
                    });
                }
            })
        });
    }
    getCustomSelections = (initial = false, callback) => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        const api = this.props.occupancy ? `/data/calendar/custom-selection/occupancy/${clinicId}` : `/data/calendar/custom-selection/${clinicId}`;

        this.setState({ customSelections: [] }, () => {
            fetch(API_ENDPOINT + api, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.calendarFilters?.length) {
                    this.setState({ customSelections: result.calendarFilters }, () => {
                        if (callback) {
                            callback();
                        }
                    });
                }
            })
        })

    }
    deleteCustomSelection = (id) => {
        if (!id) return;

        const api = this.props.occupancy ? `/data/calendar/custom-selection/occupancy/${id}` : `/data/calendar/custom-selection/${id}`;

        fetch(API_ENDPOINT + api, {
            method: 'DELETE',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            this.setState({ deleteCustomSelectionModal: null }, () => {
                this.getCustomSelections();
            });
        })
    }



    componentDidMount() {
        this.setInitialData(true);

        if (this.props.getFiltersFromLocalStorage) {
            this.props.getFiltersFromLocalStorage(this.getFiltersFromLocalStorage);
        }

    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {

    }

    saveCustomSelection = () => {
        let data = {
            ...this.state.saveCustomSelectionModal,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup
        };
        if (!data) return;

        const id = data?._id?.length === 24 ? data._id : 'new';
        delete data._id;
        this.setState({ loadingSaveCustomSelection: true }, () => {
            const api = this.props.occupancy ? `/data/calendar/custom-selection/occupancy/${id}` : `/data/calendar/custom-selection/${id}`;

            fetch(API_ENDPOINT + api, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ saveCustomSelectionModal: null, loadingSaveCustomSelection: false });
                this.setInitialData(null, () => {
                    if (result?._id && this.setCustomSelection) {
                        this.setCustomSelection([result._id]);
                    }
                });
            })
        })


    }
    prepareDataCustomSelection = (customSelection = null) => {
        const clinicians = this.state.filter?.clinicians ?? [];
        const professions = this.state.filter?.professions ?? [];
        const eventTypes = this.state.filter?.eventTypes ?? [];

        if (!clinicians.length && !professions.length && !eventTypes.length) {
            this.setState({ error: 'Please select at least one filter'.translate(this.props.lang) });
            return;
        }
        let saveCustomSelectionModal = {
            clinicians,
            professions,
            eventTypes,
            name: ''
        };
        if (customSelection?._id) {
            saveCustomSelectionModal._id = customSelection._id;
            saveCustomSelectionModal.name = customSelection?.name;
        }
        this.setState({
            saveCustomSelectionModal,
            updateOrInsertCustomSelectionModal: null
        });
    }
    setFilter = (filter, callback = null) => {
        this.setState({ filter }, () => {
            if (callback) callback();

            if (this.props.onChange) this.props.onChange(this.state.filter);
        });
    };

    getFiltersFromLocalStorage = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;
        if (typeof window !== 'undefined') {
            let data = localStorage?.getItem('calendarFilters');
            if (data) {
                let parsedData = JSON.parse(data);
                if (parsedData[clinicId] && parsedData[clinicId].clinicians && parsedData[clinicId].professions && parsedData[clinicId].eventTypes) {
                    let filter = {
                        clinicians: parsedData[clinicId].clinicians,
                        professions: parsedData[clinicId].professions,
                        eventTypes: parsedData[clinicId].eventTypes
                    };
                    setTimeout(() => {
                        this.setFilter(filter, () => {
                            if (this.setClinicians) this.setClinicians(this.state.filter?.clinicians);
                            if (this.setGroups) this.setGroups(this.state.filter?.professions);
                            if (this.setEventTypes) this.setEventTypes(this.state.filter?.eventTypes);
                        });
                    }, 300);

                }
            }
        }
    }
    checkProfessionsWithAnySelected = (unselectedValue = null) => {
        let professionsWithAnySelected = [];
        let filter = this.state.filter;
        const clinicians = filter?.clinicians ?? [];
        let professions = filter?.professions ?? [];
        let updateProfessions = false;
        for (let i = 0; i < this.state.professions.length; i++) {
            const profession = this.state.professions[i];
            let additionalItems = profession?.members?.map((member) => member._id);
            let isAnySelected = additionalItems.some((el) => clinicians.includes(el));
            let isAllSelected = additionalItems.every((el) => clinicians.includes(el));
            let isNoneSelected = additionalItems.every((el) => !clinicians.includes(el));
            if (isAnySelected) {
                professionsWithAnySelected.push(profession._id);
            }
            if (isAllSelected && !professions.includes(profession._id)) {
                updateProfessions = true;
                professions.push(profession._id);
            }
            if (isNoneSelected && professions.includes(profession._id)) {
                updateProfessions = true;
                professions = professions.filter(el => el !== profession._id);
            }
        }

        let setObj = { professionsWithAnySelected };
        if (updateProfessions) {
            filter.professions = professions;
            setObj.filter = filter;
        }
        this.setState(setObj, () => {
            if (updateProfessions && unselectedValue && this.state.filter?.professions?.includes(unselectedValue)) {
                this.setState({ error: 'Cannot uncheck this profession because all its clinicians are selected in other professions.'.translate(this.props.lang) });
            }
            if (updateProfessions && this.setGroups) {
                if (this.setGroups) this.setGroups(this.state.filter?.professions);
            }
        });
    }


    render() {
        const saveCustomSelectionModal = this.state.saveCustomSelectionModal;
        return (
            <div className='custom-filter-calendar-wrap'>
                <div className='custom-filter-left-calendar'>
                    <CustomCalendarFilterSelect
                        placeholder={'Clinicians'.translate(this.props.lang)}
                        items={this.state.clinicians?.map((item) => {
                            return {
                                label: item.name,
                                value: item._id
                            }
                        })}
                        onChange={(values) => {
                            let filter = this.state.filter;
                            filter.clinicians = values;
                            let professions = filter?.professions;
                            let professionsForUncheck = [];

                            if (professions?.length) {
                                let selectedProfessions = this.state.professions.filter(el => professions.includes(el._id));
                                for (let i = 0; i < selectedProfessions.length; i++) {
                                    const selectedProfession = selectedProfessions[i];
                                    if (selectedProfession?.members?.length) {
                                        for (let j = 0; j < selectedProfession.members.length; j++) {
                                            const member = selectedProfession.members[j];
                                            if (!values.includes(member._id)) {
                                                professionsForUncheck.push(selectedProfession._id);
                                            }
                                        }
                                    }
                                }
                                if (professionsForUncheck?.length) {
                                    filter.professions = professions.filter(el => !professionsForUncheck.includes(el));
                                }
                            }
                            this.setFilter(filter, () => {
                                this.checkProfessionsWithAnySelected();

                                if (this.setGroups && professionsForUncheck?.length) {
                                    this.setGroups(this.state.filter?.professions);
                                }
                            });
                        }}
                        registerSetData={(setClinicians) => this.setClinicians = setClinicians}
                        lang={this.props.lang}
                        splitValueText={true}
                    />
                    <CustomCalendarFilterSelect
                        placeholder={'Groups'.translate(this.props.lang)}
                        items={this.state.professions?.map((item) => {
                            let lang = this.props.lang === 'en' ? 'en' : 'sv';
                            return {
                                label: item?.name?.[lang],
                                value: item._id,
                                additionalItems: item?.members?.map((member) => {
                                    return {
                                        label: member.name,
                                        value: member._id,
                                        checked: this.state.filter?.clinicians?.includes(member._id),
                                        onChange: (value) => {
                                            let filter = this.state.filter;
                                            if (value) {
                                                if (!filter.clinicians.includes(member._id)) {
                                                    filter.clinicians.push(member._id);
                                                }
                                            } else {
                                                filter.clinicians = filter.clinicians.filter(el => el !== member._id);
                                            }
                                            this.setFilter(filter, () => {
                                                if (this.setClinicians) this.setClinicians(this.state.filter?.clinicians);
                                                this.checkProfessionsWithAnySelected();

                                            });
                                        }
                                    }
                                })
                            }
                        })}
                        onChange={(values, unselectedValue = null) => {
                            let filter = this.state.filter;
                            filter.professions = values;
                            let selectedProfessions = this.state.professions.filter(el => values.includes(el._id));
                            let clinicians = filter.clinicians ?? [];
                            for (let i = 0; i < selectedProfessions.length; i++) {
                                const selectedProfession = selectedProfessions[i];
                                if (selectedProfession?.members?.length) {
                                    for (let j = 0; j < selectedProfession.members.length; j++) {
                                        const member = selectedProfession.members[j];
                                        if (!clinicians.includes(member._id)) {
                                            clinicians.push(member._id);
                                        }
                                    }
                                }
                            }
                            filter.clinicians = clinicians;
                            if (unselectedValue) {
                                if (unselectedValue === 'all') {
                                    filter.clinicians = [];
                                } else {
                                    let membersIncludedInSelectedGroups = [];
                                    let professions = this.state.professions.filter(el => el._id !== unselectedValue);
                                    for (let i = 0; i < professions?.length; i++) {
                                        const selectedGroup = professions[i];
                                        const groupMembers = this.state.professions?.find(obj => obj._id === selectedGroup?._id)?.members?.map((member) => member._id);
                                        const selectedGroupMembers = filter.clinicians.filter((el) => groupMembers?.includes(el));
                                        if (selectedGroupMembers?.length) {
                                            for (let j = 0; j < selectedGroupMembers.length; j++) {
                                                const selectedGroupMember = selectedGroupMembers[j];
                                                if (!membersIncludedInSelectedGroups?.includes(selectedGroupMember)) {
                                                    membersIncludedInSelectedGroups.push(selectedGroupMember);
                                                }
                                            }
                                        }
                                    }
                                    filter.clinicians = membersIncludedInSelectedGroups;
                                }
                            }

                            this.setFilter(filter, () => {
                                this.checkProfessionsWithAnySelected(unselectedValue);
                                if (this.setClinicians) this.setClinicians(this.state.filter?.clinicians);
                            });
                        }}
                        registerSetData={(setGroups) => this.setGroups = setGroups}
                        lang={this.props.lang}
                        selectedAdditionalItems={this.state.filter?.clinicians}
                        itemsWithAtLeastOneSelectedSubItem={this.state.professionsWithAnySelected}
                    />
                </div>
                <div className='custom-filter-right-calendar'>
                    <CustomCalendarFilterSelect
                        placeholder={'Events'.translate(this.props.lang)}
                        // items={this.state.eventTypes?.map((item) => {
                        //     return {
                        //         label: item?.name,
                        //         value: item._id
                        //     }
                        // })}
                        includeAdditionalItems={true}
                        items={this.state.eventTypes?.map((item) => {
                            return {
                                label: item?.name?.translate(this.props.lang),
                                value: item._id,
                                additionalItems: item?.items?.map((eventType) => {

                                    const label = item._id !== 'calendar-events' ? eventType?.name : eventType?.name?.translate(this.props.lang);
                                    return {
                                        label: label,
                                        value: eventType._id,
                                        checked: this.state.filter?.eventTypes?.includes(eventType._id),
                                        onChange: (value) => {
                                            let filter = this.state.filter;
                                            if (value) {
                                                if (!filter.eventTypes.includes(eventType._id)) {
                                                    filter.eventTypes.push(eventType._id);
                                                }
                                                if (!filter.eventTypes.includes(item._id)) {
                                                    let additionalItems = item?.items?.map((eventType) => eventType._id);
                                                    let isAnySelected = additionalItems.some((el) => filter.eventTypes.includes(el));
                                                    if (isAnySelected) {
                                                        filter.eventTypes.push(item._id);
                                                    }
                                                    // let isAllSelected = additionalItems.every((el) => filter.eventTypes.includes(el));
                                                    // if (isAllSelected) {
                                                    //     filter.eventTypes.push(item._id);
                                                    // }
                                                }
                                            } else {
                                                filter.eventTypes = filter.eventTypes.filter(el => el !== eventType._id);
                                                let additionalItems = item?.items?.map((eventType) => eventType._id);
                                                let isAnySelected = additionalItems.some((el) => filter.eventTypes.includes(el));
                                                if (!isAnySelected) {
                                                    filter.eventTypes = filter.eventTypes.filter(el => el !== item._id);
                                                }
                                            }
                                            this.setFilter(filter, () => {
                                                if (this.setEventTypes) this.setEventTypes(this.state.filter?.eventTypes);
                                            });
                                        }
                                    }
                                })
                            }
                        })}
                        onChange={(values) => {
                            let filter = this.state.filter;
                            filter.eventTypes = values;
                            this.setFilter(filter);
                        }}
                        registerSetData={(setEventTypes) => this.setEventTypes = setEventTypes}
                        lang={this.props.lang}
                        selectedAdditionalItems={this.state.filter?.eventTypes}
                    />
                    <CustomCalendarFilterSelect
                        placeholder={'Custom selection'.translate(this.props.lang)}
                        actionButton={{
                            icon: saveIcon,
                            onClick: () => {
                                let selectedSelectionId = this.state.filter?.selectedSelection;
                                let customSelection = this.state.customSelections.find(obj => obj._id === selectedSelectionId);
                                if (customSelection?._id) {
                                    this.setState({ updateOrInsertCustomSelectionModal: customSelection });
                                } else {
                                    this.prepareDataCustomSelection();

                                }
                            }
                        }}
                        inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                        items={this.state.customSelections?.map((item) => {
                            return {
                                label: item?.name,
                                value: item._id
                            }
                        })}
                        onChange={(values) => {
                            const value = values?.[0];
                            let filter = {
                                clinicians: [],
                                professions: [],
                                eventTypes: this.state.eventTypes?.map((item) => item._id),
                                selectedSelection: null
                            }

                            let customSelection = this.state.customSelections.find(obj => obj._id === value);
                            if (customSelection) {
                                filter.clinicians = customSelection?.clinicians ?? [];
                                filter.professions = customSelection?.professions ?? [];
                                filter.eventTypes = customSelection?.eventTypes ?? [];
                                filter.selectedSelection = customSelection?._id;
                            }
                            this.setFilter(filter, () => {
                                if (this.setClinicians) this.setClinicians(this.state.filter?.clinicians);
                                if (this.setGroups) this.setGroups(this.state.filter?.professions);
                                if (this.setEventTypes) this.setEventTypes(this.state.filter?.eventTypes);
                            });

                        }}
                        singleSelect={true}
                        registerSetData={(setCustomSelection) => this.setCustomSelection = setCustomSelection}
                        removeHandler={(value) => {
                            let customSelection = this.state.customSelections.find(obj => obj._id === value);
                            if (customSelection) {
                                this.setState({ deleteCustomSelectionModal: customSelection });
                            }
                        }}
                        lang={this.props.lang}
                    />
                </div>
                {
                    saveCustomSelectionModal ?
                        <Modal
                            isOpen={saveCustomSelectionModal}
                            toggle={() => this.setState({ saveCustomSelectionModal: null })}
                            className='save-custom-selection-modal'
                            centered
                            zIndex={99999}
                        >
                            <ModalHeader toggle={() => this.setState({ saveCustomSelectionModal: null })}>
                                {'Save custom selection'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Name your selection'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={saveCustomSelectionModal?.name}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            let data = saveCustomSelectionModal;
                                            data.name = value;
                                            this.setState({ saveCustomSelectionModal: data });
                                        }}
                                    />
                                </FormGroup>

                                <div className='custom-selection-preview'>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Clinicians'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.clinicians?.length ?
                                                saveCustomSelectionModal.clinicians.map((item, index) => {
                                                    const name = this.state.clinicians.find(obj => obj._id === item)?.name;
                                                    return (
                                                        <div className='custom-selection-preview-item-value' key={index}>
                                                            {name}
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>

                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Groups'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.professions?.length ?
                                                saveCustomSelectionModal.professions.map((item, index) => {
                                                    const name = this.state.professions.find(obj => obj._id === item)?.name?.[this.props.lang];
                                                    return (
                                                        <div className='custom-selection-preview-item-value' key={index}>
                                                            {name}
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Events'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.eventTypes?.length ?
                                                saveCustomSelectionModal.eventTypes.map((item, index) => {
                                                    const eventType = this.state.eventTypes.find(obj => obj._id === item)
                                                    const name = eventType?.name?.translate(this.props.lang);
                                                    const selectedItems = eventType?.items?.filter((el) => saveCustomSelectionModal.eventTypes.includes(el._id));
                                                    return (
                                                        <div className='custom-selection-preview-item-value' key={index}>
                                                            {name}
                                                            {
                                                                selectedItems?.length ?
                                                                    selectedItems?.map((subItem, sIdx) => {
                                                                        const subItemName = eventType._id !== 'calendar-events' ? subItem?.name : subItem?.name?.translate(this.props.lang);
                                                                        return (
                                                                            <div className='custom-selection-preview-subitem-value' key={sIdx}>
                                                                                {subItemName}
                                                                            </div>
                                                                        )
                                                                    })
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>
                                <Button
                                    color="primary"
                                    disabled={!saveCustomSelectionModal?.name?.trim() || this.state.loadingSaveCustomSelection}
                                    onClick={() => {
                                        this.saveCustomSelection();
                                        this.setState({ saveCustomSelectionModal: null });
                                    }}
                                >
                                    {'Save'.translate(this.props.lang)}
                                </Button>
                                <Button color="primary" onClick={() => this.setState({ saveCustomSelectionModal: null })}>{'Close'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                            zIndex={9999}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.deleteCustomSelectionModal ?
                        <DeleteModal
                            zIndex={99999}
                            lang={this.props.lang}
                            isOpen={this.state.deleteCustomSelectionModal}
                            toggle={() => this.setState({ deleteCustomSelectionModal: null })}
                            handler={() => {
                                this.deleteCustomSelection(this.state.deleteCustomSelectionModal?._id);
                            }}
                        >
                            {'Delete custom selection'.translate(this.props.lang)} <strong>{this.state.deleteCustomSelectionModal && this.state.deleteCustomSelectionModal.name}</strong>?
                        </DeleteModal>
                        :
                        null
                }
                {
                    this.state.updateOrInsertCustomSelectionModal ?
                        < InfoModal
                            zIndex={99999}
                            isOpen={this.state.updateOrInsertCustomSelectionModal}
                            header={'Info'.translate(this.props.lang)}
                            info={'Do you want to update selected custom selection or create new?'.translate(this.props.lang)}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    let customSelection = { ...this.state.updateOrInsertCustomSelectionModal };
                                    this.prepareDataCustomSelection(customSelection);
                                }}>{'Update'.translate(this.props.lang)}</Button>,
                                <Button color='primary' onClick={() => {
                                    this.prepareDataCustomSelection();
                                }}>{'Create new'.translate(this.props.lang)}</Button>,
                                <Button color='primary' onClick={() => {
                                    this.setState({ updateOrInsertCustomSelectionModal: null })
                                }}>{'Close'.translate(this.props.lang)}</Button>

                            ]}
                        />
                        :
                        null
                }
            </div>


        )
    }
}

export default CustomFilterCalendar;